module.exports = __webpack_public_path__ + "img/materials.5869e3b9.svg";